import React from 'react';
import LegalDocumentLayout from '../components/LegalDocumentLayout';
import { LEGAL_LINKS } from '../data/legalLinks';
import { privacySections } from '../data/legalContent';

const BASE = 'https://antologia.tech';

const PrivacyPolicyPage = () => (
  <LegalDocumentLayout
    title="Политика обработки персональных данных"
    description="Условия обработки персональных данных на сайте antologia.tech: цели, сроки, права субъекта, контакты оператора."
    canonical={`${BASE}${LEGAL_LINKS.privacy}`}
    sections={privacySections}
  />
);

export default PrivacyPolicyPage;
